// Recovered compiled webpack factory 86343. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      computeChangedPath: function () {
        return u;
      },
      extractPathFromFlightRouterState: function () {
        return l;
      },
      getSelectedParams: function () {
        return function e(t, r) {
          for (let n of (void 0 === r && (r = {}), Object.values(t[1]))) {
            let t = n[0],
              o = Array.isArray(t),
              i = o ? t[1] : t;
            !i ||
              i.startsWith(a.PAGE_SEGMENT_KEY) ||
              (o && ("c" === t[2] || "oc" === t[2])
                ? (r[t[0]] = t[1].split("/"))
                : o && (r[t[0]] = t[1]),
              (r = e(n, r)));
          }
          return r;
        };
      },
    }));
  let n = r(57630),
    a = r(65360),
    o = r(7460),
    i = (e) => ("string" == typeof e ? ("children" === e ? "" : e) : e[1]);
  function s(e) {
    return (
      e.reduce((e, t) => {
        let r;
        return "" === (t = "/" === (r = t)[0] ? r.slice(1) : r) || (0, a.isGroupSegment)(t)
          ? e
          : e + "/" + t;
      }, "") || "/"
    );
  }
  function l(e) {
    var t;
    let r = Array.isArray(e[0]) ? e[0][1] : e[0];
    if (r === a.DEFAULT_SEGMENT_KEY || n.INTERCEPTION_ROUTE_MARKERS.some((e) => r.startsWith(e)))
      return;
    if (r.startsWith(a.PAGE_SEGMENT_KEY)) return "";
    let o = [i(r)],
      u = null != (t = e[1]) ? t : {},
      c = u.children ? l(u.children) : void 0;
    if (void 0 !== c) o.push(c);
    else
      for (let [e, t] of Object.entries(u)) {
        if ("children" === e) continue;
        let r = l(t);
        void 0 !== r && o.push(r);
      }
    return s(o);
  }
  function u(e, t) {
    let r = (function e(t, r) {
      let [a, s] = t,
        [u, c] = r,
        f = i(a),
        d = i(u);
      if (n.INTERCEPTION_ROUTE_MARKERS.some((e) => f.startsWith(e) || d.startsWith(e))) return "";
      if (!(0, o.matchSegment)(a, u)) {
        var p;
        return null != (p = l(r)) ? p : "";
      }
      for (let t in s)
        if (c[t]) {
          let r = e(s[t], c[t]);
          if (null !== r) return i(u) + "/" + r;
        }
      return null;
    })(e, t);
    return null == r || "/" === r ? r : s(r.split("/"));
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
